// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bs-header{display:flex;padding:1em 0}`, "",{"version":3,"sources":["webpack://./bs-ui/src/components/panel/header/BsPanelHeader.scss"],"names":[],"mappings":"AAAA,WACE,YAAA,CACA,aAAA","sourcesContent":[".bs-header {\n  display: flex;\n  padding: 1em 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
